import { resetDialog } from "../../../ducks/templateActivation";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import QuestionSync from "./QuestionSync";
import { syncQuestions } from "../../../ducks/templatelist";

const mapStateToProps = (state, ownProps) => {
  return {
    show: ownProps.show,
    template: ownProps.template
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    actions: bindActionCreators(
      {
        resetDialog,
        syncQuestions
      },
      dispatch
    ),
    externalActions: {
      close: ownProps.close
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(QuestionSync);
